import { render, staticRenderFns } from "./BePrompt.vue?vue&type=template&id=5aef5694&scoped=true"
import script from "./BePrompt.vue?vue&type=script&lang=js"
export * from "./BePrompt.vue?vue&type=script&lang=js"
import style0 from "./BePrompt.vue?vue&type=style&index=0&id=5aef5694&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aef5694",
  null
  
)

export default component.exports